import React, { AnchorHTMLAttributes, ReactChild } from 'react';

interface OwnProps {
  anchorProps: AnchorHTMLAttributes<HTMLAnchorElement>;
  children: ReactChild;
}

const SafeAnchor = ({ anchorProps, children }: OwnProps) => {
  return (
    <a target='_blank' rel='noreferrer noopener' {...anchorProps}>{children}</a>
  );
};

export default SafeAnchor;
